import useIntl from '@/hooks/useIntl';
import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const NoAccess: React.FC = () => {
    const t = useIntl();

    return (
        <Result
            status="403"
            title="403"
            subTitle={<h2>{t('pages.403.sorry')}</h2>}
            extra={
                <Button size="large" type="primary" onClick={() => history.push('/')}>
                    {t('pages.403.back')}
                </Button>
            }
        />
    );
};

export default NoAccess;
